import { render } from "./Marketplace.vue?vue&type=template&id=2206f88f&scoped=true"
import script from "./Marketplace.vue?vue&type=script&lang=js"
export * from "./Marketplace.vue?vue&type=script&lang=js"

import "./Marketplace.vue?vue&type=style&index=0&id=2206f88f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2206f88f"]])

export default __exports__